import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function EditName({ open, onClose, user, reload }) {
  const [newValue, setNewValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Set default name when modal opens
  useEffect(() => {
    if (open && user?.name) {
      setNewValue(user.name);
    }
  }, [open, user]);

  const handleSave = useCallback(async () => {
    if (isLoading) return; // avoid double click

    if (!newValue.trim()) {
      toast.error("Name cannot be empty");
      return;
    }

    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: user.id,
      user_name: newValue.trim(),
      user_password: "",
    };

    try {
      const response = await backend.edit_user_details(payload);

      if (response.error === "False") {
        toast.success(response.message);
        reload?.();
        onClose?.();
      } else {
        toast.error(response.message || "Failed to update name");
      }
    } catch (error) {
      toast.error("Network error! Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, [newValue, user, isLoading]);

  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[99999] backdrop-blur-sm">
      <div className="bg-[var(--background)] border-2 border-[var(--hover)] rounded-xl shadow-xl w-[90%] max-w-md p-6 animate-fadeIn">
        
        {/* Title */}
        <h2 className="text-lg font-semibold text-[var(--text)] mb-4">
          ✏️ Edit Name
        </h2>

        {/* Input */}
        <input
          type="text"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          className="w-full border-1 bg-[var(--background)] text-[var(--text)] border-[var(--hover)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-1 focus:ring-[var(--primary)] "
          placeholder="Enter new name"
          autoFocus
        />

        {/* Actions */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 bg-[var(--sell)] rounded-lg text-sm font-semibold text-white transition disabled:opacity-50"
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            disabled={isLoading}
            className="px-5 py-2 bg-[var(--primary)] rounded-lg text-sm font-semibold text-white  transition disabled:opacity-50"
          >
            {isLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
